<!--
 * @Author: Niklaus
 * @Date: 2026-04-30 11:19:33
 * @LastEditTime: 2026-05-06 18:15:12
 * @LastEditors: Niklaus
 * @Description: 报修工单及问题反馈详情
-->
<template>
    <basic-container isCard :body-style="{ padding: '0', height: '100%' }" class="h-100p">
        <!-- 自写查询数 -->
        <el-form :inline="true" label-width="80px" class="wid-100">
            <el-form-item :label="params.model.includes('repair') ? '报修人' : '反馈人'">
                <el-input v-model="form.applicant_name" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker size="medium" class="w-100p" v-model="form.applicant_time" :unlink-panels="true"
                    value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onLoad" size="medium">搜 索</el-button>
                <el-button @click="reset" size="medium">重 置</el-button>
            </el-form-item>

        </el-form>
        <div class="h-100p">
            <avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" :page.sync="page"
                @on-load="onLoad" class="custom">
                <template slot="menuLeft" slot-scope="scope">
                    <el-button size="small" type="primary" icon="el-icon-download" @click="exportData()">导出
                    </el-button>
                </template>
            </avue-crud>

        </div>
    </basic-container>
</template>
<script>
import dayjs, { Dayjs } from "dayjs"
import { getWeek } from '@/util/date'
import { getDictionary } from "@/api/system/dictbiz";
import { getMetaCommonList, getMetaCommonListExport } from '@/api/busiMode/metaCommon';
export default {
    data() {
        return {
            loading: true,
            page: {
                size: 10,
                current: 1,
                total: 0,
            },
            form: { repairType: '', applicant_time: [], create_time: [] },
            option: {
                dateBtn: false,
                border: true,
                height: 'auto',
                tip: true,
                searchShowBtn: false,
                searchMenu: false,
                searchShow: false,
                addBtn: false,
                refreshBtn: false,
                addRowBtn: false,
                columnBtn: false,
                rowKey: '',
                showPage: true,
                index: true,
                indexLabel: '序号',
                selection: false,
                showHeader: true,
                expand: false,
                highlightCurrentRow: true,
                stripe: false,
                menu: false,
                column: [
                    {
                        align: 'left',
                        label: '报修类型',
                        prop: '报修类型',
                        width: 110,
                    },
                    {
                        align: 'left',
                        label: '报修人',
                        prop: 'applicant_name',
                        width: 110,
                    },
                    {
                        align: 'left',
                        label: '联系方式',
                        prop: 'applicant_phone',
                        width: 110,
                    },
                    {
                        align: 'left',
                        label: '报修时间',
                        prop: 'applicant_time',
                        width: 140,
                    },
                    {
                        align: 'left',
                        label: '进度',
                        prop: 'status_text',
                        width: 110
                    },
                    {
                        align: 'left',
                        label: '报修位置',
                        prop: 'location_name',
                        width: 220,
                        overHidden: true
                    },
                    {
                        align: 'left',
                        label: '详情描述',
                        prop: 'repair_desc',
                        overHidden: true
                    },

                ],
            },
            data: [],
            typeList: [],
            column: [
                {
                    align: 'left',
                    label: '问题类型',
                    prop: '问题类型',
                    width: 110,
                },
                {
                    align: 'left',
                    label: '反馈人',
                    prop: 'applicant_name',
                    width: 110,
                },
                {
                    align: 'left',
                    label: '联系方式',
                    prop: 'applicant_phone',
                    width: 110,
                },
                {
                    align: 'left',
                    label: '反馈时间',
                    prop: 'create_time',
                    width: 140,
                },
                {
                    align: 'left',
                    label: '状态',
                    prop: '状态',
                    width: 110
                },
                {
                    align: 'left',
                    label: '详情描述',
                    prop: 'problem_desc',
                    overHidden: true
                },

            ],
        };
    },

    props: {
        params: {
            type: Object,
            required: true,
        },

    },

    created() {
        if (!this.params.model.includes('repair')) {
            this.option.column = this.column
        }
        this.getDict()
    },
    methods: {

        /**
         * @Author: Niklaus
         * @Description: 获取列表数据
         */
        onLoad() {
            this.loading = true;
            console.log(this.params.model)
            let body = {
                current: this.page.currentPage || 1,
                size: this.page.pageSize || 10,
                orders: this.params.model.includes('repair') ? [{ field: "applicant_time", sort: "DESC" }] : [{ field: "create_time", sort: "DESC" }],
                wheres: this.autoUpdateWheres()
            };
            getMetaCommonList(this.params.model, body).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
            });
        },
        /**
         * @Author: Niklaus
         * @Description: 导出数据
         */
        exportData() {
            this.downLoading = true
            let body = {
                current: 1,
                size: 100,
                orders: this.params.model.includes('repair') ? [{ field: "applicant_time", sort: "DESC" }] : [{ field: "create_time", sort: "DESC" }],
                wheres: this.autoUpdateWheres()
            };

            getMetaCommonListExport(this.params.model, body).then((res) => {
                this.downLoading = false
                let url = window.URL.createObjectURL(new Blob([res.data]))
                let a = document.createElement("a")
                a.style.display = "none"
                a.href = url
                a.download = this.params.name + `明细导出数据.xlsx`
                document.body.appendChild(a)
                a.click()
            })
        },

        async getDict() {
            let res = await getDictionary({ code: 'RepairServerType' })
            this.typeList = res.data.data
        },

        autoUpdateWheres() {
            let wheres = [{ field: this.params.model.includes('repair') ? 'repair_type' : 'problem_type', value: this.params.index }]
            Object.keys(this.form).forEach(key => {
                if (this.form[key]) {
                    if (key != 'applicant_time' && key != 'create_time') {
                        wheres.push({ field: key, op: 'LIKE', value: this.form[key] })
                    } else if (this.form[key].length > 0) {
                        let f = 'applicant_time'
                        if (!this.params.model.includes('repair')) {
                            f = 'create_time'
                        }
                        wheres.push({ field: f, op: 'GE', value: this.form[key][0] + ' 00:00:00' })
                        wheres.push({ field: f, op: 'LE', value: this.form[key][1] + ' 23:59:59' })
                    }
                }
            })

            return wheres
        },

        reset() {
            Object.keys(this.form).forEach(key => {
                if (key == 'create_time' && key == 'applicant_time') {
                    this.form[key] = []
                } else {
                    this.form[key] = ''
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.custom .avue-crud__menu {
    display: none !important;
    height: 0;
    min-height: 0;
}

.demo-form-inline {
    padding: 20px 15px 0 20px;
}

/deep/.el-date-range-picker {
    z-index: 9999 !important;
}
</style>
